import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trash2, Building, MapPin, DollarSign } from 'lucide-react';
import type { Job } from '../../../types/job';

interface SavedJobCardProps {
  job: Job;
  onRemove: () => void;
}

export function SavedJobCard({ job, onRemove }: SavedJobCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/jobs/${job.id}`);
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div
      onClick={handleClick}
      className="bg-background-dark rounded-xl p-4 cursor-pointer hover:bg-[#212121] transition-colors"
    >
      <div className="flex items-start space-x-4">
        <img
          src={job.logo}
          alt={`${job.company} logo`}
          className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
        />
        <div className="flex-grow min-w-0">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-gray-100 font-medium">{job.title}</h3>
              <p className="text-gray-400 text-sm mt-0.5">{job.company}</p>
              <div className="flex items-center space-x-4 mt-2">
                <div className="flex items-center text-gray-400 text-xs">
                  <MapPin className="h-3 w-3 mr-1" />
                  {job.location}
                </div>
                <div className="flex items-center text-gray-400 text-xs">
                  <Building className="h-3 w-3 mr-1" />
                  {job.type}
                </div>
                <div className="flex items-center text-gray-400 text-xs">
                  <DollarSign className="h-3 w-3 mr-1" />
                  {job.salary}
                </div>
              </div>
            </div>
            <button
              onClick={handleRemove}
              className="p-2 text-gray-400 hover:text-red-500 rounded-lg hover:bg-background-card transition-colors"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}